import React, { Component } from "react";
import axios from "axios";
import { API_BASE_URL,  TYPE_SUCCESS, TYPE_FAIL, INTERVAL, SAMPLE_FILE_URL, AMR_COLUMN_SELECTION_TRUE_VALUE } from 'assets/constants/Constants';
import { REFRESH_ICON, EXCEL_DWN_ICON, GRAPH_ICON, MAP_MARKER_ICON } from "assets/constants/Icons";
import Spinner from "components/Spinner";
import GraphLoader from "components/GraphLoader";
import MaterialTable from "material-table";
import { validateIsoDateFormat, defaultFormatDateTime, validateBitStatusAlarms } from "lib/utils";
import CSVFileReader from 'components/CSVFileReader';
import ShowToast from 'components/ShowToast';
import Select from "react-select";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";
import TableChartIcon from "@mui/icons-material/TableChart";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import DescriptionIcon from "@material-ui/icons/Description";
import DatePicker from "react-datepicker";
import { AllMeterMapViewComponent } from "lib/allMetersMapView";
import { hasRolesPermissionValue } from "components/Permission";

const SBEM_BRAND_LOGO_B64 = "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";

/**
 * @param {object} siteData
 * @returns {string}
 */
const _getExportLeftLogo = (siteData) => {
    const primary = siteData?.client_logoImage_primary?.base64Data;
    return (primary && primary.trim()) ? primary.trim() : SBEM_BRAND_LOGO_B64;
};

/**
 * @param {string} base64Data
 * @param {'pdf'|'excel'} target
 * @returns {string}
 */
const _detectLogoFormat = (base64Data, target = 'pdf') => {
    const isJpeg = base64Data?.startsWith('/9j/') || base64Data?.startsWith('/9j/4AAQ');
    const fmt = isJpeg ? 'jpeg' : 'png';
    return target === 'pdf' ? fmt.toUpperCase() : fmt;
};

export class AMI_AMR_MeterReadingPage extends Component {
    constructor (props) {
        super (props)
        const permission = hasRolesPermissionValue();

        this.state = {
            isLoading: true,
            roleName: permission?.role_name,
            tableRows: [],          
            meterReadings: [],      
            meterRadarReadings: [], 
            liveSyncIconClass: "enable-icon",
            toggleLiveSyncIconClass: true,
            importList: [],
            zone: "",
            subZone: "",
            isDropDown: false,
            zoneAndSubzoneList: [],
            subzonedisabaled: true,
            cancelButtondisabaled: true,
            meterMetaMap: {},
            reportGenerateType: "",
            reportStartDate: new Date(),
            reportEndDate: new Date(),
            reportGenerateTypeOptions: [
                { label: "Daily", value: "daily" },
                { label: "Monthly", value: "monthly" },
                { label: "Custom", value: "custom" }
            ],
            allSiteMeters: [],
            siteData: {},
            siteWiseData: [],
            sectionLoading: {
                filter: true,
                readings: true,
                map: true
            },
            totalCount: 0,
            currentPage: 0,
            totalPages: 0,
            pageSize: 10
        }

        this.liveSyncIconClassToggleInterval = null;
        this.meterReadingsGetInterval = null;
    }

    arrangeReadingList = (array) => {
        const meterListArray = [...this.state.meterReadings];
        if (Array.isArray(array)) {
            array.forEach((item) => {
                const index = meterListArray.findIndex(findeItem => findeItem.meter_serial_no === item.meter_serial_no);
                if (index === -1) {
                    meterListArray.push(item)
                }
                else {
                    meterListArray[index].meter_reading = item.meter_reading;
                    meterListArray[index].meter_reading_status = item.meter_reading_status;
                    meterListArray[index].receive_date_time = item.receive_date_time;
                    meterListArray[index].alarm_type = item.alarm_type;
                    meterListArray[index].created_date_time = item.created_date_time;
                    meterListArray[index].updated_date_time = item.updated_date_time;
                }
            });
            return meterListArray;
        }
        else {
            return array;
        }
    }

    arrangeRadarReadingList = (array) => {
        const meterListArray = [...this.state.meterRadarReadings];
        if (Array.isArray(array)) {
            array.forEach((item) => {
                const index = meterListArray.findIndex(findeItem => findeItem.meter_serial_no === item.meter_serial_no);
                if (index === -1) {
                    meterListArray.push(item)
                }
                else {
                    meterListArray[index].level_distance_reading = item.level_distance_reading;
                    meterListArray[index].meter_status = item.meter_status;
                    meterListArray[index].network_time_stamp = item.network_time_stamp;
                    meterListArray[index].alarm_type = item.alarm_type;
                    meterListArray[index].created_date_time = item.created_date_time;
                    meterListArray[index].updated_date_time = item.updated_date_time;
                }
            });
            return meterListArray;
        }
        else {
            return array;
        }
    }

    async componentDidMount() {
        const siteResponse = await this.getSiteData();
        const siteData = siteResponse?.data?.result || {};
        
        let amrColumnAccess = {};
        if (siteData.amr_column_access) {
            const roleName = this.state.roleName ? this.state.roleName.toLowerCase().replace(/\s/g, "") : "";
            amrColumnAccess = siteData.amr_column_access[roleName] || {};
        }

        this.setState({
            siteData,
            amrColumnAccess
        }, async () => {
            await this.loadFilterSection();
            this.loadReadingsSection();
            this.loadMapViewSection();
        });
    }

    async loadFilterSection() {
        try {
            const [zoneAndSubzoneList] = await Promise.all([
                this.getZoneAndSubzoneList(),
            ]);

            this.setState({
                zoneAndSubzoneList: zoneAndSubzoneList.data.result,
                sectionLoading: { ...this.state.sectionLoading, filter: false },
                isLoading: false
            });
        } catch (error) {
            this.setState({
                sectionLoading: { ...this.state.sectionLoading, filter: false },
                isLoading: false
            });
        }
    }

    async loadReadingsSection() {
        try {
            const { currentPage, pageSize, zone, subZone } = this.state;
            const [response, customerResponse] = await Promise.all([
                this.getMergedReadings(currentPage + 1, pageSize, zone, subZone),
                axios.get(`${API_BASE_URL}/customer/site/${sessionStorage.getItem('siteId')}`)
            ]);
            
            const data = response?.data || {};
            const customers = customerResponse?.data?.result || [];

            this.setState({
                tableRows:   data.result || [],
                siteCustomers: customers,
                totalCount:  this.getResponseTotalCount(response),
                totalPages:  data.totalPages || 0,
                sectionLoading: { ...this.state.sectionLoading, readings: false },
                isLoading: false
            });
        } catch (error) {
            this.setState({
                sectionLoading: { ...this.state.sectionLoading, readings: false },
                isLoading: false
            });
        }
    }

    async loadMapViewSection() {
        try {
            const siteData = this.state.siteData || {};
            const siteWiseData = siteData?.sub_module_feature_value || [];
            if (!siteWiseData.includes("Location")) {
                this.setState({
                    siteWiseData,
                    sectionLoading: { ...this.state.sectionLoading, map: false },
                    isLoading: false
                });
                return;
            }
            const meterResponse = await this.getSiteMeters();
            const meterList = meterResponse?.data?.result || [];
            const meterMetaMap = meterList.reduce((acc, meterItem) => {
                const serialNo = (meterItem?.serial_number || meterItem?.meter_serial_no || "").toString().trim();
                if (serialNo) {
                    acc[serialNo] = {
                        zone: meterItem?.zone || meterItem?.zone_name || "",
                        subZone: meterItem?.subZone || meterItem?.sub_zone || meterItem?.sub_zone_name || ""
                    };
                }
                return acc;
            }, {});

            this.setState({
                meterMetaMap,
                allSiteMeters: meterList,
                siteWiseData,
                sectionLoading: { ...this.state.sectionLoading, map: false },
                isLoading: false
            });
        } catch (error) {
            this.setState({
                meterMetaMap: {},
                allSiteMeters: [],
                siteData: {},
                siteWiseData: [],
                sectionLoading: { ...this.state.sectionLoading, map: false },
                isLoading: false
            });
        }
    }

    componentWillUnmount() {
        clearInterval(this.liveSyncIconClassToggleInterval);
        clearInterval(this.meterReadingsGetInterval);
    }

    getMergedReadings = async (page = 1, limit = 10, zone = "", subZone = "") => {
        const siteId = sessionStorage.getItem('siteId');
        const zoneParam    = zone?.value    ? `&zone=${encodeURIComponent(zone.value)}`    : "";
        const subzoneParam = subZone?.value ? `&subzone=${encodeURIComponent(subZone.value)}` : "";
        return await axios.get(
            `${API_BASE_URL}/readings/AMI-AMR/${siteId}?page=${page}&limit=${limit}${zoneParam}${subzoneParam}`
        );
    }

    getMeterReadings = async (page = 1, limit = 10) => {
        return await axios.get(`${API_BASE_URL}/readings/AMI-AMR/${sessionStorage.getItem('siteId')}?page=${page}&limit=${limit}`);
    }

    getMeterRadarReadings = async (page = 1, limit = 10) => {
        return await axios.get(`${API_BASE_URL}/radar/readings/AMI-AMR/${sessionStorage.getItem('siteId')}?page=${page}&limit=${limit}`);
    }

    getZoneAndSubzoneList = async () => {
        return await axios.get(`${API_BASE_URL}/zone/subzone/${sessionStorage.getItem('siteId')}`);
    }

    getSiteMeters = async () => {
        return await axios.get(`${API_BASE_URL}/meter/site/${sessionStorage.getItem('siteId')}`);
    }

    getSiteData = async () => {
        return await axios.get(`${API_BASE_URL}/one/site/${sessionStorage.getItem('siteId')}`);
    }

    getResponseTotalCount = (response) => {
        const data = response?.data || {};
        if (typeof data.totalCount === "number") return data.totalCount;
        if (typeof data.total_count === "number") return data.total_count;
        if (typeof data.count === "number") return data.count;
        if (typeof data.total === "number") return data.total;
        if (Array.isArray(data.result)) return data.result.length;
        return 0;
    }

    zonesList = (zoneList) => {
        return zoneList.map((item) => {
            return { label: item.zone_name, value: item.zone_name };
        });
    }

    subZonesList = (zoneList) => {
        const selectedZone = this.state.zone?.value;
        if (!selectedZone) {
            return [];
        }

        const subZones = zoneList.filter((item) => {
            return selectedZone === item.zone_name;
        });

        return subZones.flatMap((item) =>
            (item.sub_zone_name || []).map((subZone) => ({
                label: subZone,
                value: subZone
            }))
        );
    }

    zoneChangeHandler = async (event) => {
        const newZone = event ? { label: event.label, value: event.value } : "";
        this.setState({
            zone: newZone,
            subZone: "",
            subzonedisabaled: !event,
            cancelButtondisabaled: !event,
            currentPage: 0,
            sectionLoading: { ...this.state.sectionLoading, readings: true }
        }, async () => {
            try {
                const response = await this.getMergedReadings(1, this.state.pageSize, newZone, "");
                const data = response?.data || {};
                this.setState({
                    tableRows:  data.result     || [],
                    totalCount: this.getResponseTotalCount(response),
                    totalPages: data.totalPages || 0,
                    sectionLoading: { ...this.state.sectionLoading, readings: false }
                });
            } catch {
                this.setState({ sectionLoading: { ...this.state.sectionLoading, readings: false } });
            }
        });
    }

    subZoneChangeHandler = async (event) => {
        const newSubZone = event ? { label: event.label, value: event.value } : "";
        this.setState({
            subZone: newSubZone,
            cancelButtondisabaled: !(this.state.zone || event),
            currentPage: 0,
            sectionLoading: { ...this.state.sectionLoading, readings: true }
        }, async () => {
            try {
                const response = await this.getMergedReadings(1, this.state.pageSize, this.state.zone, newSubZone);
                const data = response?.data || {};
                this.setState({
                    tableRows:  data.result     || [],
                    totalCount: this.getResponseTotalCount(response),
                    totalPages: data.totalPages || 0,
                    sectionLoading: { ...this.state.sectionLoading, readings: false }
                });
            } catch {
                this.setState({ sectionLoading: { ...this.state.sectionLoading, readings: false } });
            }
        });
    }

    handleCancelFilters = async () => {
        this.setState({
            zone: "",
            subZone: "",
            subzonedisabaled: true,
            cancelButtondisabaled: true,
            currentPage: 0,
            sectionLoading: { ...this.state.sectionLoading, readings: true }
        }, async () => {
            try {
                const response = await this.getMergedReadings(1, this.state.pageSize, "", "");
                const data = response?.data || {};
                this.setState({
                    tableRows:  data.result     || [],
                    totalCount: this.getResponseTotalCount(response),
                    totalPages: data.totalPages || 0,
                    sectionLoading: { ...this.state.sectionLoading, readings: false }
                });
            } catch {
                this.setState({ sectionLoading: { ...this.state.sectionLoading, readings: false } });
            }
        });
    }

    normalizeLocationValue = (value) => {
        const normalizedValue = (value ?? "").toString().trim();
        if (!normalizedValue) {
            return "";
        }

        const lowerCaseValue = normalizedValue.toLowerCase();
        if (["na", "n/a", "none", "null", "undefined", "-"].includes(lowerCaseValue)) {
            return "";
        }

        return normalizedValue;
    }

    getZoneValue = (item, meterMetaMap = {}) => {
        const directZoneValue = (
            item.zone ||
            item.Zone ||
            item.zone_name ||
            item.zoneName ||
            item.meter_zone ||
            item.meterZone ||
            item.meter_zone_name ||
            item.meterZoneName ||
            item.meterZone_name ||
            item["Meter Zone Name"] ||
            item["meter zone name"] ||
            item["zone name"] ||
            ""
        );

        const normalizedDirectZoneValue = this.normalizeLocationValue(directZoneValue);
        if (normalizedDirectZoneValue) {
            return normalizedDirectZoneValue;
        }

        const nestedZoneValue = (
            item.meter?.zone ||
            item.meter?.zone_name ||
            item.meter?.meter_zone_name ||
            item.meter?.["Meter Zone Name"] ||
            item.meter_data?.zone ||
            item.meter_data?.zone_name ||
            item.meter_data?.meter_zone_name ||
            item.meterData?.zone ||
            item.meterData?.zone_name ||
            item.meterData?.meter_zone_name ||
            item.meter_info?.zone ||
            item.meter_info?.zone_name ||
            item.meter_info?.meter_zone_name ||
            item.meterInfo?.zone ||
            item.meterInfo?.zone_name ||
            item.meterInfo?.meter_zone_name ||
            ""
        );

        const normalizedNestedZoneValue = this.normalizeLocationValue(nestedZoneValue);
        if (normalizedNestedZoneValue) {
            return normalizedNestedZoneValue;
        }

        const serialNo = (item?.meter_serial_no || item?.serial_number || "").toString().trim();
        return this.normalizeLocationValue(meterMetaMap?.[serialNo]?.zone);
    }

    getSubZoneValue = (item, meterMetaMap = {}) => {
        const directSubZoneValue = (
            item.subzone ||
            item.subZone ||
            item.Subzone ||
            item.SubZone ||
            item.sub_zone ||
            item.sub_zone_name ||
            item.subZoneName ||
            item.meter_sub_zone ||
            item.meter_sub_zone_name ||
            item.meterSubZone ||
            item.meterSubZoneName ||
            item["Meter Subzone Name"] ||
            item["Meter Sub Zone Name"] ||
            item["meter subzone name"] ||
            item["meter sub zone name"] ||
            item["subzone name"] ||
            item["sub zone name"] ||
            ""
        );

        const normalizedDirectSubZoneValue = this.normalizeLocationValue(directSubZoneValue);
        if (normalizedDirectSubZoneValue) {
            return normalizedDirectSubZoneValue;
        }

        const nestedSubZoneValue = (
            item.meter?.subzone ||
            item.meter?.sub_zone ||
            item.meter?.sub_zone_name ||
            item.meter?.meter_sub_zone_name ||
            item.meter?.["Meter Subzone Name"] ||
            item.meter_data?.subzone ||
            item.meter_data?.sub_zone ||
            item.meter_data?.sub_zone_name ||
            item.meter_data?.meter_sub_zone_name ||
            item.meterData?.subzone ||
            item.meterData?.sub_zone ||
            item.meterData?.sub_zone_name ||
            item.meterData?.meter_sub_zone_name ||
            item.meter_info?.subzone ||
            item.meter_info?.sub_zone ||
            item.meter_info?.sub_zone_name ||
            item.meter_info?.meter_sub_zone_name ||
            item.meterInfo?.subzone ||
            item.meterInfo?.sub_zone ||
            item.meterInfo?.sub_zone_name ||
            item.meterInfo?.meter_sub_zone_name ||
            ""
        );

        const normalizedNestedSubZoneValue = this.normalizeLocationValue(nestedSubZoneValue);
        if (normalizedNestedSubZoneValue) {
            return normalizedNestedSubZoneValue;
        }

        const serialNo = (item?.meter_serial_no || item?.serial_number || "").toString().trim();
        return this.normalizeLocationValue(meterMetaMap?.[serialNo]?.subZone);
    }

    showMeterReadingHandler = (item) => {
        if(item){
            const rowItem = {
                serial_number:item.meter_serial_no,
                ...item
            }
            this.props.history.push({
                pathname: "/meter-reading",
                state: {rowItem, pageName:"AMI Readings", pathName: "ami-amr-meter-reading-page"}
            });
        }
        else{
            this.props.history.push({
                pathname: "/meter-reading",
                state: null
            });
        }
    }


    handleFile = async (fileData) => {
        if (fileData[0].errors && fileData[0].errors.length === 0) {
            const importPromise = fileData.map(async (importItem, index) => {
                if (index !== 0) {
                    const innerPromiseResult = await new Promise(async (resolve) => {
                        const rawAlarmStatus = importItem.data[4] || "None"; ;
                        const alarmStatusArray = rawAlarmStatus.split(',').map(item => {
                            return item.trim();
                        });
                 
                        if (fileData[index].data[0]) {
                            resolve({
                                meter_serial_no: importItem.data[0] !== undefined ? importItem.data[0] : ""   ,
                                meter_date_time: importItem.data[1] !== undefined ?  importItem.data[1] : "" ,
                                meter_totalizer_value: importItem.data[2] !== undefined ? importItem.data[2] : "" ,
                                meter_unit: importItem.data[3] !== undefined ? importItem.data[3] : "",
                                meter_alarm_status: alarmStatusArray
                            });
                        }
                        else {
                            resolve(null);
                        }
                    });
                    return innerPromiseResult;
                }
            });

            let importResult = await Promise.all(importPromise);
            let requestParameter = null;
            importResult = importResult.filter((mapItem) => mapItem !== null);
            importResult = importResult.filter((item) => item);
            if (importResult.length > 0) {
                this.setState({
                    importList: [...importResult]
                })
            }
            const sitePromise = this.state.importList.map(async (item, index) => {
                this.setState({ isLoading: true })
                return new Promise(async (resolve) => {
                    requestParameter = {
                        meterSerialNumber: item.meter_serial_no,
                        meterDateAndTime: item.meter_date_time,
                        meterTotalizerReading: item.meter_totalizer_value,
                        meterReadingUnit: item.meter_unit,
                        meterAlarmStatus: item.meter_alarm_status,
                    }
                    const readingsResponse = await axios.post(`${API_BASE_URL}/import/csv/readings`, requestParameter);
                    resolve(readingsResponse);
                })
            });

            const meterResponse = await Promise.all(sitePromise);
            if (meterResponse.length > 0 && meterResponse.length === importResult.length) {
                ShowToast('Imported Readings created successfully', TYPE_SUCCESS, INTERVAL, this.props, "");
                this.setState({
                    importList: [],
                    isLoading: false
                });
            }

        }

        else {
            ShowToast('Something went wrong. Please try after sometime!', TYPE_FAIL, INTERVAL, this.props, "");
        }
    };

    handleRefresh = async () => {
        this.setState({ isLoading: true });
        try {
            const response = await this.getMergedReadings(1, this.state.pageSize, this.state.zone, this.state.subZone);
            const data = response?.data || {};
            this.setState({
                tableRows:   data.result     || [],
                totalCount:  this.getResponseTotalCount(response),
                totalPages:  data.totalPages || 0,
                currentPage: 0,
                isLoading: false
            });
        } catch {
            this.setState({ isLoading: false });
        }
    }

    handlePageChange = async (page, pageSize) => {
        this.setState({ sectionLoading: { ...this.state.sectionLoading, readings: true } });
        const newPageSize = pageSize || this.state.pageSize;
        try {
            const response = await this.getMergedReadings(page + 1, newPageSize, this.state.zone, this.state.subZone);
            const data = response?.data || {};
            this.setState({
                tableRows:   data.result     || [],
                totalCount:  this.getResponseTotalCount(response),
                totalPages:  data.totalPages || 0,
                currentPage: page,
                pageSize:    newPageSize,
                sectionLoading: { ...this.state.sectionLoading, readings: false }
            });
        } catch {
            this.setState({ sectionLoading: { ...this.state.sectionLoading, readings: false } });
        }
    }

    handleRowsPerPageChange = async (pageSize) => {
        this.setState({ sectionLoading: { ...this.state.sectionLoading, readings: true } });
        try {
            let actualPageSize = pageSize;
            if (typeof pageSize === 'object' && pageSize !== null && pageSize.value !== undefined) {
                actualPageSize = pageSize.value;
            }
            actualPageSize = parseInt(actualPageSize, 10) || 10;
            const response = await this.getMergedReadings(1, actualPageSize, this.state.zone, this.state.subZone);
            const data = response?.data || {};
            this.setState({
                tableRows:   data.result     || [],
                totalCount:  this.getResponseTotalCount(response),
                totalPages:  data.totalPages || 0,
                currentPage: 0,
                pageSize:    pageSize,
                sectionLoading: { ...this.state.sectionLoading, readings: false }
            });
        } catch {
            this.setState({ sectionLoading: { ...this.state.sectionLoading, readings: false } });
        }
    }

    getTableData = () => {
        const { meterMetaMap, tableRows = [], siteCustomers = [] } = this.state;
        return tableRows.map((element) => {
            const zone    = (this.getZoneValue(element, meterMetaMap)    || "").toString().trim() || "NA";
            const subzone = (this.getSubZoneValue(element, meterMetaMap) || "").toString().trim() || "NA";
            const customer = siteCustomers.find(c => c.serial_number && (Array.isArray(c.serial_number) ? c.serial_number.includes(element.meter_serial_no) : String(c.serial_number).includes(String(element.meter_serial_no)))) || {};
            return {
                meter_serial_no:   element.meter_serial_no,
                customer_name:     customer.customer_name || "None",
                consumer_no:       customer.consumer_no || "None",
                mobile_no:         customer.mobile_no || "None",
                email_id:          customer.email_id || "None",
                zone,
                subzone,
                receive_date_time: validateIsoDateFormat(element.receive_date_time)
                    ? defaultFormatDateTime(element.receive_date_time)
                    : element.receive_date_time,
                last_collected_date: element.last_collected_date && validateIsoDateFormat(element.last_collected_date)
                    ? defaultFormatDateTime(element.last_collected_date)
                    : element.last_collected_date || "NA",
                meter_reading:     element.meter_reading != null ? element.meter_reading : "NA",
                last_collected_reading: element.last_collected_reading != null ? element.last_collected_reading : "NA",
                meter_status:      element.meter_status,
                receiver:          element.receiver || "AMI",
                gway_device_id:    element.gway_device_id  || "NA",
                field_strengthG:   element.field_strengthG || "NA",
                alarm_type:        validateBitStatusAlarms(element.alarm_type),
            };
        });
    }

    getFilteredTableData = () => {
        return this.getTableData();
    }

    getCurrentPageExportRows = () => {
        return this.getFilteredTableData();
    }

    getExportColumns = () => {
        const customLabels = this.state.siteData?.custom_amr_column_labels || {};
        const allColumns = [
            { title: customLabels.serial_number || "Serial Number", field: "meter_serial_no" },
            { title: customLabels.customer_name || "Customer Name", field: "customer_name" },
            { title: customLabels.consumer_no || "Consumer No", field: "consumer_no" },
            { title: customLabels.mobile_no || "Mobile No", field: "mobile_no" },
            { title: customLabels.email_id || "Email ID", field: "email_id" },
            { title: customLabels.zone || "Zone", field: "zone" },
            { title: customLabels.subzone || "Subzone", field: "subzone" },
            { title: customLabels.receive_date_time || "Date", field: "receive_date_time" },
            { title: customLabels.readings || "Reading", field: "meter_reading" },
            { title: "Last Collected Date", field: "last_collected_date" },
            { title: "Last Collected Reading", field: "last_collected_reading" },
            { title: customLabels.meter_status || "Meter Status", field: "meter_status" },
            { title: customLabels.device_type || "Receiver", field: "receiver" },
            { title: customLabels.gateway_device_id || "Gateway Device ID", field: "gway_device_id" },
            { title: customLabels.rssi || "Field Strength", field: "field_strengthG" },
            { title: customLabels.alarm_type || "Alarm Type", field: "alarm_type" }
        ];

        const roleName = this.state.roleName ? this.state.roleName.toLowerCase().replace(/\s/g, "") : "";
        const columnAccess = this.state.siteData?.amr_column_access?.[roleName] || {};
        
        const fieldMapping = {
            "meter_serial_no": "serial_number",
            "customer_name": "customer_name",
            "consumer_no": "consumer_no",
            "mobile_no": "mobile_no",
            "email_id": "email_id",
            "zone": "zone",
            "subzone": "subzone",
            "receive_date_time": "receive_date_time",
            "meter_reading": "readings",
            "meter_status": "meter_status",
            "receiver": "device_type",
            "gway_device_id": "gateway_device_id",
            "field_strengthG": "rssi",
            "alarm_type": "alarm_type"
        };

        return this.state.siteData?.amr_column_selection === AMR_COLUMN_SELECTION_TRUE_VALUE
            ? allColumns.filter(col => columnAccess[fieldMapping[col.field]] !== false)
            : allColumns.filter(col => ["meter_serial_no", "customer_name", "consumer_no", "mobile_no", "email_id", "zone", "subzone", "receive_date_time", "meter_reading", "last_collected_date", "last_collected_reading", "meter_status", "receiver", "gway_device_id", "field_strengthG", "alarm_type"].includes(col.field));
    }

    getExportHeaders = () => {
        return this.getExportColumns().map(c => c.title);
    }

    getExportRows = (rows) => {
        const columns = this.getExportColumns();
        return rows.map(row => columns.map(c => row[c.field] ?? "NA"));
    }

    getFormattedExportDateTime = () => {
        const now = new Date();
        const pad = (value) => String(value).padStart(2, "0");
        const day = pad(now.getDate());
        const month = pad(now.getMonth() + 1);
        const year = now.getFullYear();
        const hour12 = now.getHours() % 12 || 12;
        const minutes = pad(now.getMinutes());
        const seconds = pad(now.getSeconds());
        const meridiem = now.getHours() >= 12 ? "pm" : "am";
        return `${day}-${month}-${year} ${pad(hour12)}-${minutes}-${seconds} ${meridiem}`;
    }

    sanitizeForFileName = (value) => {
        return String(value).replace(/[\\/:*?"<>|]/g, "-");
    }

    getExportBaseFileName = () => {
        const stateSiteName = this.state?.siteData?.site_name;
        const siteName = (
            stateSiteName ||
            sessionStorage.getItem("siteName") ||
            sessionStorage.getItem("site_name") ||
            sessionStorage.getItem("site") ||
            "Site"
        ).trim();

        const zoneLabel = this.state.zone?.label;
        const subZoneLabel = this.state.subZone?.label;

        let zoneSubZonePart = "";
        if (zoneLabel && subZoneLabel) {
            zoneSubZonePart = ` - ${this.sanitizeForFileName(zoneLabel)}-${this.sanitizeForFileName(subZoneLabel)}`;
        } else if (zoneLabel) {
            zoneSubZonePart = ` - ${this.sanitizeForFileName(zoneLabel)}`;
        } else if (subZoneLabel) {
            zoneSubZonePart = ` - ${this.sanitizeForFileName(subZoneLabel)}`;
        }

        return `AMI-AMR All Reading Data - ${this.state?.zone?.label ? `${this.state.zone.label}-` : ""}${this.state?.subZone?.label ? `${this.state.subZone.label}-` : ""}${siteName} - ${this.getFormattedExportDateTime()}`;
    }

    handleExportPDF = () => {
        const rows = this.getCurrentPageExportRows();
        const siteData = this.state.siteData || {};
        const columns = this.getExportColumns();
        const doc = new jsPDF("l", "pt", "a2");
        const pageWidth = doc.internal.pageSize.getWidth();
        const headerHeight = 85;

        let dateText = `Generated: ${moment().format("DD-MM-YYYY hh:mm:ss a")}`;

        const zoneText = this.state.zone?.label
            ? ` | Zone: ${this.state.zone.label}`
            : "";

        const subZoneText = this.state.subZone?.label
            ? ` | Subzone: ${this.state.subZone.label}`
            : "";

        dateText += zoneText + subZoneText;

        doc.setFillColor(230, 230, 230);
        doc.rect(0, 0, pageWidth, headerHeight, "F");

        doc.setDrawColor(120, 120, 120);
        doc.setLineWidth(1);
        doc.rect(0, 0, pageWidth, headerHeight);

        doc.line(110, 0, 110, headerHeight);
        doc.line(pageWidth - 110, 0, pageWidth - 110, headerHeight);

        const leftLogoB64 = _getExportLeftLogo(siteData);
        const leftLogoFmt = _detectLogoFormat(leftLogoB64, 'pdf');
        doc.addImage(
            `data:image/${leftLogoFmt.toLowerCase()};base64,${leftLogoB64}`,
            leftLogoFmt,
            8,
            10,
            94,
            65
        );

        if (siteData?.client_logoImage_secondary?.base64Data) {
            const rightLogoFmt = _detectLogoFormat(siteData.client_logoImage_secondary.base64Data, 'pdf');
            doc.addImage(
                `data:image/${rightLogoFmt.toLowerCase()};base64,${siteData.client_logoImage_secondary.base64Data}`,
                rightLogoFmt,
                pageWidth - 76,
                10,
                68,
                55
            );
        }

        const displayClientName = (
            siteData?.client_name ||
            sessionStorage.getItem("clientName") ||
            sessionStorage.getItem("client_name") ||
            sessionStorage.getItem("client") ||
            "Client Name"
        ).trim();

        const displaySiteName = (
            siteData?.site_name ||
            sessionStorage.getItem("siteName") ||
            sessionStorage.getItem("site_name") ||
            sessionStorage.getItem("site") ||
            "Site Name"
        ).trim();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text(displayClientName, pageWidth / 2, 24, { align: "center" });

        doc.setFontSize(12);
        doc.text(displaySiteName, pageWidth / 2, 46, { align: "center" });

        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        doc.text(dateText, pageWidth / 2, 68, { align: "center" });

        autoTable(doc, {
            startY: 100,
            head: [["Sr No", ...columns.map((c) => c.title)]],
            body: rows.map((row, index) => [index + 1, ...columns.map((c) => row[c.field] ?? "")]),
            styles: {
                fontSize: 7,
                cellPadding: 2,
                halign: "center",
                valign: "middle"
            },
            headStyles: {
                fillColor: [0, 112, 192],
                textColor: [255, 255, 255],
                fontStyle: "bold",
                fontSize: 7
            },
            alternateRowStyles: {
                fillColor: [242, 242, 242]
            }
        });

        doc.save(`${this.getExportBaseFileName()}.pdf`);
    }

    handleExportCSV = () => {
        const rows = this.getCurrentPageExportRows();
        const headers = this.getExportHeaders();
        const bodyRows = this.getExportRows(rows);
        const csvContent = [headers, ...bodyRows]
            .map((csvRow) => csvRow.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(","))
            .join("\n");
        saveAs(new Blob([csvContent], { type: "text/csv;charset=utf-8;" }), `${this.getExportBaseFileName()}.csv`);
    }

    handleExportExcel = async () => {
        const rows = this.getCurrentPageExportRows();
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("AMI-AMR Reading Data");
        const siteData = this.state.siteData || {};

        const cols = this.getExportColumns();

        const leftLogoB64 = _getExportLeftLogo(siteData);
        const leftLogoId  = workbook.addImage({ base64: leftLogoB64, extension: _detectLogoFormat(leftLogoB64, 'excel') });
        worksheet.addImage(leftLogoId, { tl: { col: 0, row: 0 }, br: { col: 2, row: 4 } });

        if (siteData?.client_logoImage_secondary?.base64Data) {
            const rightLogoB64 = siteData.client_logoImage_secondary.base64Data;
            const rightLogoId  = workbook.addImage({ base64: rightLogoB64, extension: _detectLogoFormat(rightLogoB64, 'excel') });
            worksheet.addImage(rightLogoId, { tl: { col: Math.max(3, cols.length - 2), row: 0 }, br: { col: Math.max(5, cols.length), row: 4 } });
        }

        const defaultWidths = {
            meter_serial_no: 18,
            customer_name: 24,
            consumer_no: 18,
            mobile_no: 16,
            email_id: 24,
            zone: 18,
            subzone: 18,
            receive_date_time: 24,
            meter_reading: 18,
            meter_status: 20,
            receiver: 16,
            gway_device_id: 24,
            field_strengthG: 18,
            alarm_type: 22
        };

        cols.forEach((col, index) => {
            worksheet.getColumn(index + 1).width = defaultWidths[col.field] || 20;
        });

        worksheet.getRow(1).height = 28;
        worksheet.getRow(2).height = 28;
        worksheet.getRow(3).height = 24;
        worksheet.getRow(4).height = 8;
        worksheet.getRow(6).height = 24;

        const maxHeaderMergeCol = Math.max(4, cols.length - 2);
        worksheet.mergeCells(1, 3, 1, maxHeaderMergeCol);
        worksheet.mergeCells(2, 3, 2, maxHeaderMergeCol);
        worksheet.mergeCells(3, 3, 3, maxHeaderMergeCol);

        const applyBorder = (cell) => {
            cell.border = {
                top: { style: "thin", color: { argb: "000000" } },
                left: { style: "thin", color: { argb: "000000" } },
                bottom: { style: "thin", color: { argb: "000000" } },
                right: { style: "thin", color: { argb: "000000" } }
            };
        };

        for (let row = 1; row <= 3; row++) {
            for (let col = 3; col <= maxHeaderMergeCol; col++) {
                const cell = worksheet.getCell(row, col);
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "D9D9D9" }
                };
                applyBorder(cell);
            }
        }

        for (let row = 1; row <= 4; row++) {
            for (let col = 1; col <= 2; col++) {
                applyBorder(worksheet.getCell(row, col));
            }
        }

        if (cols.length >= 3) {
            for (let row = 1; row <= 4; row++) {
                for (let col = Math.max(5, cols.length - 1); col <= Math.max(6, cols.length); col++) {
                    applyBorder(worksheet.getCell(row, col));
                }
            }
        }

        const xlsxClientName = (
            siteData.client_name ||
            sessionStorage.getItem("clientName") ||
            sessionStorage.getItem("client_name") ||
            sessionStorage.getItem("client") ||
            "Client Name"
        ).trim();

        const xlsxSiteName = (
            siteData.site_name ||
            sessionStorage.getItem("siteName") ||
            sessionStorage.getItem("site_name") ||
            sessionStorage.getItem("site") ||
            "Site Name"
        ).trim();

        worksheet.getCell("C1").value = xlsxClientName;
        worksheet.getCell("C1").font = { name: "Arial", size: 20, bold: true };
        worksheet.getCell("C1").alignment = { horizontal: "center", vertical: "middle" };

        worksheet.getCell("C2").value = xlsxSiteName;
        worksheet.getCell("C2").font = { name: "Arial", size: 16, bold: true };
        worksheet.getCell("C2").alignment = { horizontal: "center", vertical: "middle" };

        let excelDateText = `Generated: ${moment().format("DD-MM-YYYY hh:mm:ss a")}`;

        const excelZoneText = this.state.zone?.label
            ? ` | Zone: ${this.state.zone.label}`
            : "";

        const excelSubZoneText = this.state.subZone?.label
            ? ` | Subzone: ${this.state.subZone.label}`
            : "";

        excelDateText += excelZoneText + excelSubZoneText;

        worksheet.getCell("C3").value = excelDateText;
        worksheet.getCell("C3").font = { name: "Arial", size: 12 };
        worksheet.getCell("C3").alignment = { horizontal: "center", vertical: "middle" };

        const headerRowNumber = 6;
        cols.forEach((col, index) => {
            const cell = worksheet.getCell(headerRowNumber, index + 1);
            cell.value = col.title;
            cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 12 };
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "0070C0" } };
            cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" }
            };
        });

        rows.forEach((row, rowIndex) => {
            const excelRowNumber = headerRowNumber + 1 + rowIndex;
            cols.forEach((col, colIndex) => {
                const cell = worksheet.getCell(excelRowNumber, colIndex + 1);
                cell.value = row[col.field] ?? "";
                cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                };
                if (rowIndex % 2 === 0) {
                    cell.fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "F2F2F2" }
                    };
                }
            });
            worksheet.getRow(excelRowNumber).height = 22;
        });

        worksheet.views = [{ state: "frozen", ySplit: headerRowNumber }];

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(
            new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
            `${this.getExportBaseFileName()}.xlsx`
        );
    }


    reportGenerateTypeChangeHandler = (event) => {
        const isDaily = event?.value === "daily";
        const isCustom = event?.value === "custom";
        this.setState({
            reportGenerateType: event || "",
            reportEndDate: (isDaily || isCustom) ? new Date() : this.state.reportEndDate
        });
    }

    handleReportStartDateChange = (date) => {
        const isMonthly = this.state.reportGenerateType?.value === "monthly";
        if (isMonthly) {
            const start = moment(date).startOf("month").toDate();
            this.setState({
                reportStartDate: start,
                reportEndDate: null
            });
            return;
        }

        const nextStart = date;
        const nextEnd =
            this.state.reportEndDate && nextStart && this.state.reportEndDate < nextStart
                ? nextStart
                : this.state.reportEndDate;

        this.setState({
            reportStartDate: nextStart,
            reportEndDate: nextEnd
        });
    }

    handleReportEndDateChange = (date) => {
        const isMonthly = this.state.reportGenerateType?.value === "monthly";
        if (isMonthly) {
            const end = moment(date).endOf("month").toDate();
            this.setState({
                reportEndDate: end
            });
            return;
        }

        this.setState({
            reportEndDate: date
        });
    }

    getLast12Months = () => {
        const today = new Date();
        return {
            minDate: new Date(today.getFullYear(), today.getMonth() - 11, 1),
            maxDate: new Date(today.getFullYear(), today.getMonth(), 1),
        };
    };

    handleMenuOpen = () => {
        this.setState({ isDropDown: true });
    };

    handleMenuClose = () => {
        this.setState({ isDropDown: false });
    };

    render () {
        if (this.state.isLoading) {
            return (
                <Spinner />
            );
        }
        else {
            const { zoneAndSubzoneList } = this.state;
            const filteredTableData = this.getFilteredTableData();

            const customLabels = this.state.siteData?.custom_amr_column_labels || {};
            const allColumns = [
                { title: customLabels.serial_number || "Serial Number", field: "meter_serial_no", cellStyle:{color:"#000000", fontSize: 14} },
                { title: customLabels.customer_name || "Customer Name", field: "customer_name", cellStyle:{color:"#808080", fontSize: 14} },
                { title: customLabels.consumer_no || "Consumer No", field: "consumer_no", cellStyle:{color:"#808080", fontSize: 14} },
                { title: customLabels.mobile_no || "Mobile No", field: "mobile_no", cellStyle:{color:"#808080", fontSize: 14} },
                { title: customLabels.email_id || "Email ID", field: "email_id", cellStyle:{color:"#808080", fontSize: 14} },
                { title: customLabels.zone || "Zone", field: "zone", cellStyle:{color:"#808080", fontSize: 14} },
                { title: customLabels.subzone || "Subzone", field: "subzone", cellStyle:{color:"#808080", fontSize: 14} },
                { title: customLabels.receive_date_time || "Date", field: "receive_date_time", cellStyle:{color:"#808080", fontSize: 14} },
                { title: customLabels.readings || "Reading", field: "meter_reading", cellStyle:{color:"#808080", fontSize: 14} },
                { title: "Last Collected Date", field: "last_collected_date", cellStyle:{color:"#808080", fontSize: 14} },
                { title: "Last Collected Reading", field: "last_collected_reading", cellStyle:{color:"#808080", fontSize: 14} },
                { title: customLabels.meter_status || "Meter Status", field: "meter_status", cellStyle:{color:"#808080", fontSize: 14} },
                { title: customLabels.device_type || "Receiver", field: "receiver", cellStyle: (e, rowData) => {
                    if (rowData.receiver === "AMI") {
                        return { color: "blue", fontSize: 14, fontWeight: "bold"}
                    }
                    else {
                        return { color: "green", fontSize: 14, fontWeight: "bold"}
                    }
                } },
                { title: customLabels.gateway_device_id || "Gateway Device ID", field: "gway_device_id", cellStyle:{color:"#808080", fontSize: 14} },
                { title: customLabels.rssi || "Field Strength", field: "field_strengthG", cellStyle:{color:"#808080", fontSize: 14} },
                { title: customLabels.alarm_type || "Alarm Type", field: "alarm_type", cellStyle:{color:"#808080", fontSize: 14} }
            ];

            const roleName = this.state.roleName ? this.state.roleName.toLowerCase().replace(/\s/g, "") : "";
            const columnAccess = this.state.siteData?.amr_column_access?.[roleName] || {};
            
            // Map the Constants fields to our MaterialTable fields for filtering
            const fieldMapping = {
                "meter_serial_no": "serial_number",
                "customer_name": "customer_name",
                "consumer_no": "consumer_no",
                "mobile_no": "mobile_no",
                "email_id": "email_id",
                "zone": "zone",
                "subzone": "subzone",
                "receive_date_time": "receive_date_time",
                "meter_reading": "readings",
                "meter_status": "meter_status",
                "receiver": "device_type",
                "gway_device_id": "gateway_device_id",
                "field_strengthG": "rssi",
                "alarm_type": "alarm_type"
            };

            const filteredColumns = this.state.siteData?.amr_column_selection === AMR_COLUMN_SELECTION_TRUE_VALUE
                ? allColumns.filter(col => columnAccess[fieldMapping[col.field]] !== false)
                : allColumns.filter(col => ["meter_serial_no", "customer_name", "consumer_no", "mobile_no", "email_id", "zone", "subzone", "receive_date_time", "meter_reading", "last_collected_date", "last_collected_reading", "meter_status", "receiver", "gway_device_id", "field_strengthG", "alarm_type"].includes(col.field));

            return (
                <div className="main-content">
                    <div className="live-sync-ami-amr-icon-and-text-container">
                        <div className="ami-amr-image">
                            <img src="/images/153-RWM.png" alt="153 RWM" />
                        </div>
                        {/* <i className={ `${REFRESH_ICON} ${this.state.liveSyncIconClass} rotate`}></i>
                        <label className={`${this.state.liveSyncIconClass}`}>Syncing...</label> */}
                        <div className="ami-amr-heading">AMI-AMR READINGS</div>
                        <div className="live-sync-info">
                            <i
                                onClick={this.handleRefresh}
                                className={`${REFRESH_ICON}`}
                            ></i>
                        </div>
                        {/* <div className="csv-import-wrapper">
                            <CSVFileReader handleFile={this.handleFile}>
                                <button className="brand-button">Import CSV</button>
                            </CSVFileReader>
                        </div> */}
                    </div>

                    {this.state.sectionLoading.filter ? (
                        <div className="pie-chart-spinner-wrapper-loading">
                            <GraphLoader />
                        </div>
                    ) : (
                        <div className="live-sync-ami-amr-after-text-container filter-changes" style={{ paddingBottom: this.state.isDropDown === true ? "13%" : "2%" }}>
                            <div className="zone-select-container">
                                <Select
                                    className="site-select-dropdown"
                                    value={this.state.zone}
                                    placeholder={`Select ${customLabels.zone || "Zone"}`}
                                    options={this.zonesList(zoneAndSubzoneList)}
                                    onChange={this.zoneChangeHandler}
                                    onMenuOpen={this.handleMenuOpen}
                                    onMenuClose={this.handleMenuClose}
                                    menuPlacement="bottom"
                                />
                            </div>

                            <div className="subzone-select-container">
                                <Select
                                    className="site-select-dropdown"
                                    value={this.state.subZone}
                                    placeholder={`Select ${customLabels.subzone || "Subzone"}`}
                                    options={this.subZonesList(zoneAndSubzoneList)}
                                    onChange={this.subZoneChangeHandler}
                                    isDisabled={this.state.subzonedisabaled}
                                    onMenuOpen={this.handleMenuOpen}
                                    onMenuClose={this.handleMenuClose}
                                    menuPlacement="bottom"
                                />
                            </div>

                            <button type="button" className="brand-button report-button" disabled={this.state.cancelButtondisabaled} onClick={this.handleCancelFilters}>
                                CLEAR
                            </button>
                        </div>
                    )}

                    <div className="border list-table-div" style={{marginBottom:50}}>
                        {this.state.sectionLoading.readings ? (
                            <div className="pie-chart-spinner-wrapper-loading">
                                <GraphLoader />
                            </div>
                        ) : filteredTableData.length > 0 ? (
                            <MaterialTable
                                columns={filteredColumns}
                                data={filteredTableData}
                                onRowClick = {(event, rowData) => {
                                    this.showMeterReadingHandler(rowData)
                                }}
                                actions={[
                                    {
                                        icon: () => (
                                            <div style={{ display: "flex", alignItems: "center", color: "#d32f2f", fontWeight: 500, fontSize: 15 }}>
                                                <PictureAsPdfIcon style={{ marginRight: 4 }} />
                                                PDF
                                            </div>
                                        ),
                                        tooltip: "Export PDF",
                                        isFreeAction: true,
                                        onClick: this.handleExportPDF
                                    },
                                    {
                                        icon: () => (
                                            <div style={{ display: "flex", alignItems: "center", color: "#2e7d32", fontWeight: 500, fontSize: 15 }}>
                                                <DescriptionIcon style={{ marginRight: 4 }} />
                                                Excel
                                            </div>
                                        ),
                                        tooltip: "Export Excel",
                                        isFreeAction: true,
                                        onClick: this.handleExportExcel
                                    },
                                    {
                                        icon: () => (
                                            <div style={{ display: "flex", alignItems: "center", color: "#1565c0", fontWeight: 500, fontSize: 15 }}>
                                                <TableChartIcon style={{ marginRight: 4 }} />
                                                CSV
                                            </div>
                                        ),
                                        tooltip: "Export CSV",
                                        isFreeAction: true,
                                        onClick: this.handleExportCSV
                                    }
                                ]}
                                options={{
                                    headerStyle: {
                                        color: "#0070C0",
                                        fontWeight: "bold",
                                        fontSize: 15
                                    },
                                    paging: true,
                                    filtering: true,
                                    search: true,
                                    pageSize: this.state.pageSize,
                                    pageSizeOptions: [10, 50, 75, 100, { value: this.state.totalCount > 0 ? this.state.totalCount : 9999999, label: 'All' }],
                                    exportFileName: this.getExportBaseFileName()
                                }}
                                onChangePage={this.handlePageChange}
                                onChangeRowsPerPage={this.handleRowsPerPageChange}
                                page={this.state.currentPage}
                                totalCount={this.state.totalCount}
                            />
                        ) : (
                            <div className="text-center pt-2">
                                <label>Records not found!</label>
                            </div>
                        )}
                    </div>

                    {/*<div className="report-section" >
                        <i className={`${EXCEL_DWN_ICON} icon-space`}></i>
                        <span>READINGS REPORT AND GRAPH GENERATE</span>
                    </div>

                    <div>
                        <div className="pt-4 mt-4 mb-5 pb-4 border list-table-div">
                            <div className="row">
                                <div className="addUser">
                                    <label className="form-label">Select Date To Generate Excel And Graph <span className="text-danger">*</span></label>
                                    <Select
                                        className="site-select-dropdown"
                                        value={this.state.reportGenerateType}
                                        placeholder="Select Date"
                                        options={this.state.reportGenerateTypeOptions}
                                        onChange={this.reportGenerateTypeChangeHandler}
                                        menuPlacement="bottom"
                                    />
                                </div>
                            </div>

                            {this.state.reportGenerateType?.value === "monthly" && (
                                <div className="row">
                                    <div className="addUser">
                                        <label className="form-label">From Month <span className="text-danger">*</span></label>
                                        <div className="calender-div">
                                            <span className="icon fa-calendar" />
                                            <DatePicker
                                                className="form-control brand-font p-3"
                                                calendarClassName="monthly-calendar"
                                                selected={this.state.reportStartDate}
                                                onChange={(date) => this.handleReportStartDateChange(date)}
                                                showMonthYearPicker
                                                dateFormat="dd/MM/yyyy"
                                                minDate={this.getLast12Months().minDate}
                                                maxDate={this.getLast12Months().maxDate}
                                            />
                                        </div>
                                    </div>
                                    <div className="addUser">
                                        <label className="form-label">To Month <span className="text-danger">*</span></label>
                                        <div className="calender-div">
                                            <span className="icon fa-calendar" />
                                            <DatePicker
                                                className="form-control brand-font p-3"
                                                calendarClassName="monthly-calendar"
                                                selected={this.state.reportEndDate}
                                                onChange={(date) => this.handleReportEndDateChange(date)}
                                                showMonthYearPicker
                                                dateFormat="dd/MM/yyyy"
                                                minDate={this.state.reportStartDate}
                                                maxDate={this.getLast12Months().maxDate}
                                                disabled={!this.state.reportStartDate}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {this.state.reportGenerateType && this.state.reportGenerateType?.value !== "monthly" && (
                                <div className="row">
                                    <div className="addUser">
                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                        <div className="calender-div">
                                            <span className="icon fa-calendar" />
                                            <DatePicker
                                                className="form-control brand-font p-3"
                                                selected={this.state.reportStartDate}
                                                onChange={(date) => this.handleReportStartDateChange(date)}
                                                dateFormat="dd/MM/yyyy"
                                                maxDate={new Date()}
                                            />
                                        </div>
                                    </div>
                                    <div className="addUser">
                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                        <div className="calender-div">
                                            <span className="icon fa-calendar" />
                                            <DatePicker
                                                className="form-control brand-font p-3"
                                                selected={this.state.reportEndDate}
                                                onChange={(date) => this.handleReportEndDateChange(date)}
                                                dateFormat="dd/MM/yyyy"
                                                minDate={this.state.reportStartDate || undefined}
                                                maxDate={new Date()}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="ami-amr-report-action-row">
                                <button
                                    type="button"
                                    className="brand-button report-button"
                                    onClick={() => {}}
                                >
                                    GET REPORT
                                </button>
                                <button
                                    id="download-excel-button"
                                    className="download-table-xls-button brandxls-button download-button"
                                    onClick={() => {}}
                                >
                                    Download
                                </button>
                            </div>
                        </div>
                    </div>*/}

                    {/*<div className="report-section">
                        <i className={`${GRAPH_ICON} icon-space`}></i>
                        <span>CONSUMPTION GRAPH VIEW</span>
                    </div>

                    <div className="live-sync-icon-after-text-container">
                        <div className="line-chart">
                            <div className="ami-amr-graph-placeholder-simple">
                                <h5>Consumption Report</h5>
                                <div className="ami-amr-blank-graph-canvas">
                                    <div className="ami-amr-blank-graph-grid"></div>
                                    <div className="ami-amr-blank-graph-label">Graph will appear hear</div>
                                </div>
                            </div>
                        </div>
                    </div>*/}
                    
                    {this.state.sectionLoading.map ? (
                        <div className="ami-amr-map-view-wrapper">
                            <div className="pie-chart-spinner-wrapper-loading">
                                <GraphLoader />
                            </div>
                        </div>
                    ) : (
                        <>
                            {this.state.siteWiseData?.includes("Location") && (
                                <>
                                    <div className="report-section">
                                        <i className={`${MAP_MARKER_ICON} icon-space`}></i>
                                        <span>METERS MAP VIEW</span>
                                    </div>

                                    <div className="ami-amr-map-view-wrapper">
                                        <AllMeterMapViewComponent markers={this.state.allSiteMeters} />
                                    </div>
                                </>
                            )}
                        </>
                    )}
                </div>
            );
        }
    }
}

export default AMI_AMR_MeterReadingPage;